import { apiSlice } from "./ApiSlice";

const GetReportsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    GetLabReports: builder.query({
      query: (userclinicid) => ({
        url: `api/ClinicProfile/GetLabTestPatientInfo?userClinicID=${userclinicid}`,
        method: "GET",
      }),
    }),

    AddLabReports: builder.mutation({
      query: (formData) => ({
        url: `/api/ClinicProfile/Add-Lab-Reports`,
        method: "POST",
        body: formData,
      }),
    }),

    PostFilteredLabReports: builder.mutation({
      query: (data) => ({
        url: `/api/ClinicProfile/LabReportsTableFilter`,
        method: "POST",
        body: data,
      }),
    }),

    GetLabReportsList: builder.query({
      query: (userclinicid) => ({
        url: `/api/ClinicProfile/GetLabReportsListView?userClinicID=${userclinicid}`,
        method: "GET",
      }),
    }),

    GetLabReportsDoctorsList: builder.query({
      query: ({userclinicid,doctorUserUniqueID}) => ({
        url: `/api/ClinicProfile/GetLabReportsListView?userClinicID=${userclinicid}&doctorUserUniqueID=${doctorUserUniqueID}`,
        method: "GET",
      }),
    }),

    GetLabReportsOverview: builder.query({
      query: ({ appointmentID, patientUserUniqueID }) => ({
        url: `/api/ClinicProfile/Get-LabReports-Overview?patientUserUniqueID=${patientUserUniqueID}&appointmentID=${appointmentID}`,
        method: "GET",
      }),
    }),

    Getlabresults: builder.query({
      query: (patientUserUniqueID) => {
        return {
          url: `/api/ClinicProfile/GetPatientOverview-Lab-History?patientUserUniqueID=${patientUserUniqueID}`,
          method: "GET"
        };
      },
    }),

    Getdoctorlabresults: builder.query({
      query: ({patientUserUniqueID,DoctorUserUniqueID}) => {
        return {
          url: `/api/ClinicProfile/GetPatientOverview-Lab-History?patientUserUniqueID=${patientUserUniqueID}&DoctorUserUniqueID=${DoctorUserUniqueID}`,
          method: "GET"
        };
      },
    }),


  }),
});

export const {
  useLazyGetLabReportsQuery,
  useAddLabReportsMutation,
  usePostFilteredLabReportsMutation,
  useLazyGetLabReportsListQuery,
  useLazyGetLabReportsOverviewQuery,
  useLazyGetLabReportsDoctorsListQuery,
  useLazyGetlabresultsQuery,
  useLazyGetdoctorlabresultsQuery
} = GetReportsApiSlice;
